import { authTexts } from 'consts/text';
import { InstitutionType } from 'types';

export const institutionTypeItems: { label: string; value: InstitutionType }[] = [
    {
        label: authTexts.kinderGardenOptionLabel,
        value: 'KINDERGARTEN',
    },
    {
        label: authTexts.nurseryOptionLabel,
        value: 'NURSERY',
    },
    {
        label: authTexts.kidsClubOptionLabel,
        value: 'KIDS_CLUB',
    },
    {
        label: authTexts.schoolOptionLabel,
        value: 'SCHOOL',
    },
    {
        label: authTexts.otherInstitutionOptionLabel,
        value: 'OTHER',
    },
];
